import React from 'react'
import ExPostGoToFinish from './ExPostGoToFinish';

function Index(
    {
        expanded
    }) {
    return (
        expanded && <ExPostGoToFinish/>
    )
}

export default Index;